import {EventEmitter, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {CommandService} from '@core/services/command.service';
import {IPlatformToolHandler} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {PlatformCommand, PlatformCommandResponse} from '@shared/commands/command-base';
import {take, takeUntil} from 'rxjs/operators';
import {MagicLinkModel, TabModel} from '@shared/models/platform-tool-models';
import {Router} from '@angular/router';
import {DialogService} from '@shared/services/dialog-service';
import {Subject} from 'rxjs';
import {FuseSplashScreenService} from '@barebone-fuse-services/splash-screen.service';
import {select, Store} from '@ngrx/store';
import {IQueryState} from '@shared/store/reducers/query.reducer';
import {SnackBarService} from '@core/services/snack-bar.service';
import {FileManagementService} from '@core/services/file-management.service';
import {GridValueChangeEvent} from '@shared/models/common.models';
import {MemberDialogModel, ShareItemService} from '@shared/services/share-item.service';
import {ShareFileCommand} from '@features/file-manager/commands/create-directory.command';
import {FileManagerService} from '@features/file-manager/services/file-manager.service';
import {FileStoreCommonService} from '@features/file-manager/services/file-store-common.service';
import {ContextMenuAction, IconViewModel} from '@features/file-manager/models/file-manager.model';
import {PlatformSidebarState} from '@shared/components/platform-sidebar/store/platform-sidebar.reducer';
import {VirtualGridSelectionService} from '@core/services/virtual-grid-selection.service';
import {
  SetActivityFeedAction,
  SetCurrentRightSideComponentAction
} from '@shared/components/platform-sidebar/store/platform-sidebar.action';
import {RootDynamicComponentHelper} from '@shared/helpers/root-dynamic-component-helper';
import {ItpDesktopUtilityService} from '@core/services/itpdesktopservices/itp-desktop-utility.service';
import {PlatformQuery} from '@shared/models/platform-query/platform-query';
import {PlatformQueryService} from '@core/services/platform-query.service';
import {ItpDesktopService} from '@core/services/itpdesktopservices/itp-desktop.service';
import {Configuration} from '@shared/models/configuration';
import {UpdateFieldDefinitionCommand} from '@shared/commands/update-field-definition.command';
import {ParticleConfig} from '@features/particle-config';
import {GetSmartGridFieldSectionInfosAction} from '@shared/store/actions/smart-grid.actions';
import {GetFieldSectionsAction} from '@shared/store/actions/virtual-grid.actions';
import {FlowChartDataService} from '@features/data-survey/services/flow-chart-data.service';
import {Api} from '@shared/constants/common-field.constants';
import {IToastState} from '@shared/store/toast/toast-reducer';
import {getCurrentToast, getNotification} from '@shared/store/toast/toast-selectors';
import {DismissToastSuccessAction} from '@shared/store/toast/toast-actions';
import {LoadProjectSuccessAction} from '@features/projects/store/actions/projects.actions';
import {ProjectState} from '@features/projects/store/reducers/projects.reducer';
import {StringUtility} from '@shared/utility/string-utility';
import {Guid} from 'guid-typescript';
import {BasketProvider} from '@shared/models/basket-provider';
import {ChangeBasketAction} from '@shared/store/actions/particle.actions';
import {QnrPermissions} from '@features/data-survey/components/flow-chart/models/qnr.models';
import {EliteFormFlowChartDataService} from '@features/elite-form/services/elite-form-flow-chart-data.service';
import { FormResponseViewService } from '../services/form-response-view.service';


@Injectable({
  providedIn: 'root',
})
export class PlatformToolEliteFormHandler implements IPlatformToolHandler {

  magicLinkModel: MagicLinkModel;
  ngUnsubscribe$ = new Subject<void>();
  magicLinkModelValueChanged: EventEmitter<any> = new EventEmitter<any>();
  invalidateSubject: InvalidateSubject;
  metaData: any = {};
  isDesktop: string;
  currentRoute = '';
  defaultBoardPermission = {
    'title': 'Manager',
    'description': 'Manage all content and members',
    'permissionType': 104
  };

  constructor(private httpClient: HttpClient,
              private commandService: CommandService,
              private router: Router,
              private dialogService: DialogService,
              private fuseSplashScreenService: FuseSplashScreenService,
              protected store: Store<IQueryState>,
              private snackBarService: SnackBarService,
              protected fileManagementService: FileManagementService,
              protected fileManagerService: FileManagerService,
              protected shareItemService: ShareItemService,
              private fileStoreCommonService: FileStoreCommonService,
              private platformSidebarStore: Store<PlatformSidebarState>,
              private itpDesktopService: ItpDesktopService,
              private itpDesktopUtilityService: ItpDesktopUtilityService,
              private virtualGridSelectionService: VirtualGridSelectionService,
              private platformQueryService: PlatformQueryService,
              private queryState: Store<IQueryState>,
              private toastStore: Store<IToastState>,
              private projectStore: Store<ProjectState>,
              private flowChartDataService: FlowChartDataService,
              private eliteFormFlowChartDataService: EliteFormFlowChartDataService,
              private formResponseViewService: FormResponseViewService) {
    this.flowChartDataService.setApi(Api.FileStoreApi);
  }

  private static setRelatedFieldKeyPropertiesInCommand(event: any, command: any) {
    if (event.fieldDefinition['RelatedFieldKeyToUpdate']) {
      const relatedFieldKeyToUpdate = event.fieldDefinition['RelatedFieldKeyToUpdate'];
      const relatedFieldKeyValue = event.item.cells[relatedFieldKeyToUpdate]?.value;
      const relatedFieldKeyDisplayText = event.item.cells[relatedFieldKeyToUpdate]?.displayText;
      command.fieldValues['RelatedFieldKey'] = relatedFieldKeyToUpdate;
      command.fieldValues[relatedFieldKeyToUpdate] = relatedFieldKeyValue;
      if (relatedFieldKeyDisplayText) {
        command.fieldValues[relatedFieldKeyToUpdate + 'DisplayText'] = relatedFieldKeyDisplayText;
      }
    }
  }

  executeCommand(command: PlatformCommand, callBack?: any) {
    //command.fieldValues['IsClientSchema'] = this.eliteFormFlowChartDataService.isClientSchema;
    //command.fieldValues['SchemaId'] = this.eliteFormFlowChartDataService.schemaId;
    //command.fieldValues['ResponseId'] = this.eliteFormFlowChartDataService.responseId;

    if (!command.api) {
      const downloadUrl = command.fieldValues['DownloadUrl'];
      if (downloadUrl) {
        this.fileManagementService.downloadOneTimeSignedUrl(downloadUrl, command.fieldValues['FileName']);
      }
    } else if (command.api && command.api.length > 0 && !command.isDisabled) {
      switch (command.name) {
        case 'UseCurrentFolderCommand':
          command.fieldValues['SelectedFolderPath'] = this.magicLinkModel.tabBar.tabs[this.magicLinkModel.tabBar.selectedIndex].tabData['RelativePath'];
          this.executeCommandToApi(command, callBack);
          break;
        case 'AddEventSourceModelCommand':
          this.manageEventSourceCommand(command);
          break;
        case 'CreatePowerbiReportCommand':
          this.invalidateSubject.invalidate('LoadingAnimation');
          this.executeCommandToApi(command);
          break;
        case 'ApplyDataMappingCommand':
        case 'ImportByDataMappingCommand':
        case 'ExportItpDataToFileCommand':
          this.fuseSplashScreenService.show();
          this.commandService.executePlatformCommand(command).subscribe(res => {
            if (res) {
              const sourceType = this.magicLinkModel.tabBar.tabs[this.magicLinkModel.tabBar.selectedIndex].tabData.SourceType;
              this.queryState.dispatch(new GetSmartGridFieldSectionInfosAction(sourceType));
              this.queryState.dispatch(new GetFieldSectionsAction(sourceType));
              if (res.fieldValues['RedirectUrl']) {
                this.fuseSplashScreenService.hide();
                this.router.navigateByUrl(res.fieldValues['RedirectUrl']);
              }
              if (res.fieldValues['RedirectCommand']) {
                this.executeCommandToApi(res.fieldValues['RedirectCommand']);
                return;
              } else {
                this.fuseSplashScreenService.hide();
              }
            }
          }, err => {
            this.fuseSplashScreenService.hide();
          });
          break;
        case 'AddPlatformFieldsCommand':
          return this.executeCommandToApi(command, callBack);
        case 'GenerateSnippetPdfCommand': {
          const downloadRequestId = Guid.create().toString();
          command.fieldValues['DownloadRequestId'] = downloadRequestId;
          this.commandService.executePlatformCommand(command);
          this.snackBarService.showInformation('Download is in progress. You will be notified shortly. Meanwhile, You may continue browsing in Orbitax.');

          this.toastStore.select(getNotification, downloadRequestId).pipe(take(2)).subscribe(notification => {
            console.log('Received Notification for Download News Command with id ' + downloadRequestId);
            console.log(notification);
            if (notification && notification.payload) {
              if (notification.status === 1 && notification.payload.fileId) {
                const downloadResponse = notification.payload;
                this.fileManagementService.downloadClientFileWithId(downloadResponse.fileId).pipe().subscribe(value => {
                  this.fileManagementService.openSaveFileWindow(value, downloadResponse.fileName);
                });
              } else {
                this.snackBarService.showError(notification.payload);
              }
            }
          });
          return;
        }
        // case 'ToggleHiddenDirectoryEntryCommand':
        //   this.fetchMagicLink(command, () => {
        //     const value = {id: 'PlatformToolContainerComponent', value: this.magicLinkModel};
        //     this.magicLinkModelValueChanged.emit(value);
        //   });
        //   break;
        case 'DirectUploadSuccessCommand':
          this.executeCommandToApi(command, () => {
            this.invalidateSubject.invalidateAlways();
          });
          break;
        case 'CopySurveyLinkCommand':
          this.executeCommandWithHandler(command, callBack);
          break;
        default:
          this.executeCommandToApi(command, callBack);
          break;
      }
    }
  }

  manageEventSourceCommand(command: PlatformCommand) {
    if (command.fieldValues['AskQuestion']) {
      const title = command.fieldValues['QuestionTitle'];
      const message = command.fieldValues['QuestionMessage'];
      const key = command.fieldValues['QuestionResponseKey'];
      this.dialogService.showConfirmDialog(title, 'Yes', 'No', message, '')
        .pipe(take(1)).subscribe(dialogResponse => {
        console.log('dialog response', dialogResponse);
        if (dialogResponse.action === 'OK') {
          command.fieldValues[key] = true;
        } else if (dialogResponse.action === 'Cancel') {
          command.fieldValues[key] = false;
        } else {
          return;
        }
        this.executeCommandToApi(command);
      });
    } else {
      this.executeCommandToApi(command);
    }
  }

  executeCommandWithHandler(command: PlatformCommand, callBack?: any) {
    if (command.fieldValues['CommandHandler']) {
      const commandHandler = RootDynamicComponentHelper.getComponent(command.fieldValues['CommandHandler']);
      if (commandHandler) {
        commandHandler.executeCommand(command, this);
        return;
      }
    }
    this.executeCommand(command, this);
  }

  selectionChanged($event: any) {
  }

  valueChanged($event) {
    if ($event.action) {
      this.handleAction($event);
      return;
    }
    if ($event.fieldDefinition && $event.fieldDefinition.key === 'ResponseId' && this.magicLinkModel.additionalCommands['ShowResponse']) {
      const showResponseCommand = this.magicLinkModel.additionalCommands['ShowResponse'];
      showResponseCommand.fieldValues['DataItemId'] = $event.item.id;
      this.executeCommandWithHandler(showResponseCommand);
      return;
    }
    if ($event.fieldDefinition && $event.fieldDefinition.key === 'Name') {
      if ($event.item.cells['IsDrive'] && $event.item.cells['IsDrive'].value) {
        this.OpenDrive($event);
      } else if ($event.item.cells['IsFolder'].value) {
        this.OpenFolder($event);
      } else {
        this.openFile($event);
      }
      return;
    }
    if ($event.name) {
      this.handleEventsByName($event);
      return;
    }
    if ($event.fieldDefinition && $event.fieldDefinition.key === 'Header') {
      this.navigateToField($event);
      return;
    }
    if ($event.fieldDefinition && $event.fieldDefinition.key) {
      const command = this.magicLinkModel.additionalCommands[$event.fieldDefinition.key];
      command.fieldValues['ItemId'] = $event.item.id;
      this.executeCommand(command);
      return;
    }
    if ($event.item.cells['IsFlowExecution']) {
      this.executeOpenFlowExecutionCommand($event);
    }
  }

  destroy() {
    this.formResponseViewService.destroy();
    this.flowChartDataService.destroy();
    this.invalidateSubject.close();
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }

  setSelectedTab(selectedTab: TabModel): void {
    // // handling scenario case for folder
    // if (selectedTab.tabData?.DetailsHelpId &&
    //   ((!this.magicLinkModel.fieldValues.hasOwnProperty('FlowId')  || this.magicLinkModel.fieldValues.FlowId == null) && (!this.magicLinkModel.fieldValues.hasOwnProperty('NodeId')  || this.magicLinkModel.fieldValues.NodeId == null)))  {
    //   this.platformSidebarStore.dispatch(
    //     new SetCurrentRightSideComponentAction(
    //       {component: 'HelpNotesComponent', data: {isUserAction: true}, componentInfo: {id: 'HelpNotesComponent'}}));
    // }

    if (!selectedTab.tabData || !selectedTab.tabData['FormIdList']) {
      return;
    }

    const selectedFormIndexByUser = selectedTab.index;

    const selectedEliteFormIds = selectedTab.tabData['FormIdList'];
    const selectedEliteFormTitles = selectedTab.tabData['Forms'];

    const selectedFormId = selectedTab.tabData['SelectedEliteFormId'];
    const selectedFormIndex = selectedEliteFormIds.indexOf(selectedFormId);

    if(selectedFormIndexByUser === selectedFormIndex) {
      return;
    }



    const changedTabOpenFileCommand = this.magicLinkModel.additionalCommands['ChangedTabOpenFileCommand'];
    changedTabOpenFileCommand.fieldValues['SelectedEliteFormId'] = selectedEliteFormIds[selectedFormIndexByUser];

    changedTabOpenFileCommand.fieldValues['SelectedEliteFormTitle'] = selectedEliteFormTitles[selectedFormIndexByUser];
    this.executeCommand(changedTabOpenFileCommand);

  }

  markStar(event: GridValueChangeEvent): void {
    console.log('contextMenuItem', event);
    const command = new PlatformCommand('ToggleStarContentCommand', 'FileStoreApi');
    command.fieldValues['ItemId'] = event.item.id;
    command.fieldValues['IsDeleted'] = false;
    command.fieldValues['IsClientDrive'] = event.item.cells['IsClientDrive'].value;
    command.fieldValues['IsFavorite'] = event.item.cells['IsFavorite'].value;
    command.fieldValues['ParentId'] = event.item.cells['ParentId'].value;
    command.fieldValues['Type'] = event.item.cells['Type'].value;
    this.fileStoreCommonService.executeCommand(command).subscribe(res => {
      this.invalidateSubject.invalidate();
    });
  }

  openShareDialog($event) {
    const model = new MemberDialogModel();
    model.invalidateSubject = this.invalidateSubject;
    model.configKey = 'DirectoryEntrySharedMembersKey';
    model.itemId = $event.item.id;

    this.fileManagerService.getSharedMembersbyDirectoryId($event.item.id).pipe(take(1)).subscribe(item => {
      if (item) {
        const selectedUsers = this.shareItemService.mapSelectedUsers(item.userGroups);
        const contactsMetaData = {
          'selectedUsers': selectedUsers,
          'permissions': item.permissions,
          'defaultPermission': this.defaultBoardPermission
        };
        const command = new ShareFileCommand($event.item.id, []);
        command.canHaveEmptyPermissions = true;
        this.shareItemService.showDialog(model, contactsMetaData, command);
      }
    });
  }

  manageEventSourceCommandResponse(command: PlatformCommand, callBack?: any) {
    switch (command.fieldValues['CommandName']) {
      case 'UpdateExcelFromQuestionnaireResponseCommand':
        const query = new PlatformQuery();
        query.api = 'SpreadsheetApi';
        query.name = 'OpenFileQuery';
        query.fieldValues = {...command.fieldValues};
        this.platformQueryService.executeQuery(query).subscribe(response => {
          if (response.fieldValues['RedirectCommand']) {
            this.executeCommandWithHandler(response.fieldValues['RedirectCommand'], callBack);
          }
        });
        break;
    }
  }

  openDirectoryEntryCellEditor(event: any) {
    const item = Object.assign({}, event.item);
    if (item && item.cells[event.fieldDefinition.key] && event.fieldDefinition.dataType !== 'Attachment') {
      if (item.cells[event.fieldDefinition.key].value.userValue) {
        item.cells[event.fieldDefinition.key].value = item.cells[event.fieldDefinition.key].value.userValue;
      } else if (item.cells[event.fieldDefinition.key].value.actualValue) {
        item.cells[event.fieldDefinition.key].value = item.cells[event.fieldDefinition.key].value.actualValue;
      }
    }
    const minWidth = '800px';
    const maxWidth = '1500px';
    this.dialogService.showCellEditorDialog(item, event.fieldDefinition, minWidth, maxWidth,
      'ClientDirectoryEntry').subscribe(state => {
      if (state.action === 'OK') {
        this.saveFieldDefinition('ClientDirectoryEntry', state.data.input.fieldDefinition, event.fieldSection);
        const value = item.cells[event.fieldDefinition.key].value;
        const command = new PlatformCommand('UpdateDirectoryEntryFieldValueCommand', 'FileStoreApi');
        command.fieldValues['SourceType'] = 'ClientDirectoryEntry';
        command.fieldValues['FieldKey'] = event.fieldDefinition.key;
        command.fieldValues['ItemId'] = item.id;
        command.fieldValues['Value'] = value;
        command.fieldValues['IsClientDrive'] = item.cells['IsClientDrive']?.value;
        this.fileStoreCommonService.executeCommand(command).pipe().subscribe(commandState => {
          console.log(commandState);
          this.invalidateSubject.invalidate();
        });
      }
    });
  }

  moveItem($event: GridValueChangeEvent) {
    const selectedItems = this.virtualGridSelectionService.virtualGridSelection('ClientDirectoryEntry');
    if (selectedItems.itemSelections.length === 0) {
      this.fileStoreCommonService.OpenMoveDialog(true, [this.fileStoreCommonService.getIconViewModel($event.item)]);
    } else {
      const items: IconViewModel[] = [];
      selectedItems.itemSelections.forEach(o => {
        items.push(this.fileStoreCommonService.getIconViewModel(o));
      });
      this.fileStoreCommonService.OpenMoveDialog($event.item.cells['IsClientDrive']?.value, items);
    }
    return true;
  }

  deleteItems($event: GridValueChangeEvent) {
    const selectedItems = this.virtualGridSelectionService.virtualGridSelection('ClientDirectoryEntry');
    const items: IconViewModel[] = [];
    selectedItems.itemSelections.forEach(o => {
      items.push(this.fileStoreCommonService.getIconViewModel(o));
    });
    this.fileStoreCommonService.openDeleteFileOrFolderConfirmationDialog(items);
  }

  saveFieldDefinition(sourceType: string, fieldDefinition: any, selectedFieldSection: any) {
    let fieldSettings = null;
    if (fieldDefinition && fieldDefinition.configKey) {
      const fieldConfig = Configuration.getSmartGridConfig(fieldDefinition.configKey);
      if (fieldConfig && fieldConfig.FieldSettings) {
        fieldSettings = fieldConfig.FieldSettings;
      }
    }
    if (fieldSettings) {
      const rootUrlKey = Configuration.getSmartGridConfig(sourceType).RootUrlKey;
      const url = `${Configuration.getConfig(rootUrlKey)}FieldSection/UpdateFieldDefinition`;
      const config = Configuration.getSmartGridConfig(sourceType);
      if (config) {
        const updateFieldDefinitionCommand = new UpdateFieldDefinitionCommand([fieldDefinition],
          selectedFieldSection.id, ParticleConfig.ApplicationId, sourceType, true,
          url, !Configuration.getSmartGridConfig(sourceType).IsCompanySpecific);
        this.commandService.executeCommand(updateFieldDefinitionCommand).pipe().subscribe(state => {
          selectedFieldSection = selectedFieldSection.fieldGroups.map(fieldGroup => {
            if (fieldGroup.definitions[0].key === state['Payload'][0].Key) {
              fieldGroup.definitions[0].options = state['Payload'][0].Options.map(option => {
                return {
                  id: option.Id,
                  isCustom: option.IsCustom,
                  tags: option.Tags,
                  text: option.Text
                };
              });
            }
            return fieldGroup;
          });
          this.invalidateSubject.invalidate();
        });
      }
    }
  }

  saveQuestionnaireFieldDefinition(fieldDefinition, section) {
    this.flowChartDataService.addOrUpdateFieldDefinitionInFlowChartCommandExecute(fieldDefinition, 'Question',
      'UPDATE', section, '', false, {}).then(() => {
    });
  }

  onBeforeLoad(): void {
    this.switchBasket();
  }

  getActivityForViewActivityInQuestionnaire() {
    const activityCommand = new PlatformCommand('TrackActivityForQuestionnaireGridCommand', 'FileStoreApi');
    activityCommand.fieldValues['DirectoryId'] = this.magicLinkModel.fieldValues['DirectoryId'];
    activityCommand.fieldValues['ChangeFieldType'] = ['ViewActivityInQuestionnaire'];
    return activityCommand;
  }

  sendNecessaryActivityCommand(command: PlatformCommand) {
    switch (command.name) {
      case 'ImportFromQuestionnaireCommand':
        const activityCommand = new PlatformCommand('TrackActivityForQuestionnaireGridCommand', 'FileStoreApi');
        activityCommand.setValue('DirectoryEntryId', command.fieldValues.DirectoryEntryId);
        activityCommand.setValue('FlowchartId', command.fieldValues.FlowchartId);
        activityCommand.setValue('ChangeFieldType', ['ExportToToolFromQuestionnaire']);
        this.commandService.executePlatformCommand(activityCommand).pipe(take(1)).subscribe(res => {
          console.log(res);
        });
    }
  }

  public invalidateGridDataIfNeeded(sourceType) {
    this.queryState.dispatch(new GetSmartGridFieldSectionInfosAction(sourceType));
    this.queryState.dispatch(new GetFieldSectionsAction(sourceType));
  }

  private fetchMagicLink(command: PlatformCommand, callback: Function) {
    command.name = 'OpenFolderCommand';
    this.commandService.executePlatformCommand(command).pipe(takeUntil(this.ngUnsubscribe$)).subscribe(
      data => {
        this.magicLinkModel = data.fieldValues['PlatformLinkModel'];
        callback(data);
      },
      error => {
        this.fuseSplashScreenService.hide();
        console.error('Information bar error', error);
      }
    );
  }

  private subscribeForToastNotification() {
    this.toastStore.pipe(select(getCurrentToast), takeUntil(this.ngUnsubscribe$)).subscribe(res => {
      if (res && res.type === 'ItpDesktop') {
        console.log('Toast');
        if (res.commands) {
          let project = res.commands[0].fieldValues['ProjectModel'];
          if (project) {
            project = StringUtility.convertKeysCamelToPascal(project);
            this.projectStore.dispatch(new LoadProjectSuccessAction(project, '', false));
          }
          this.toastStore.dispatch(new DismissToastSuccessAction(res));
          this.currentRoute = this.router.url;
          if (this.currentRoute.includes('/drive/')) {
            this.router.navigateByUrl(res.commands[0].fieldValues['RedirectUrl']);
          }
        }
      }
    });
  }

  private OpenDrive($event) {
    this.magicLinkModel.additionalCommands['Open'].fieldValues['DriveId'] = $event.item.id;
    this.magicLinkModel.additionalCommands['Open'].fieldValues['FeatureId'] = $event.item.featureId;
    this.executeCommandWithHandler(this.magicLinkModel.additionalCommands['Open']);
  }

  private OpenFolder($event) {
    this.magicLinkModel.additionalCommands['Open'].fieldValues['DriveId'] = $event.item.cells['DriveId'].value;
    this.magicLinkModel.additionalCommands['Open'].fieldValues['ItemId'] = $event.item.id;
    this.magicLinkModel.additionalCommands['Open'].fieldValues['ViewType'] = 'GridView';
    this.executeCommandWithHandler(this.magicLinkModel.additionalCommands['Open']);
  }

  private handleAction($event: GridValueChangeEvent) {
    if ($event.item.type === 'QuestionnaireResponse') {
      this.questionnaireResponseAction($event);
      return;
    }
    if (this.handleDriveActions($event)) {
      return;
    } else {
      const command = this.magicLinkModel.additionalCommands[$event.action.id];
      if (command) {
        command.fieldValues['DriveId'] = $event.item.id;
        command.fieldValues['ItemId'] = $event.item.id;
        if ($event.action.id === 'ToggleStarContent') {
          command.fieldValues['IsFavorite'] = $event.item.cells['IsFavorite']?.value;
          command.fieldValues['Type'] = $event.item.cells['Type']?.value;
        }
        this.executeCommandWithHandler(command);
        return;
      }
    }
  }

  private questionnaireResponseAction($event: GridValueChangeEvent) {
    switch ($event.action.id) {
      case 'Show Activity':
        let referenceCode = $event.item.cells['ReferenceCode']?.value;
        let referenceName = $event.item.cells['ReferenceName']?.value;
        if (referenceCode == null) {
          referenceCode = $event.item.id;
          referenceName = $event.item.cells.ResponseId?.displayText;
        }
        const activityInfo = {
          type: 'ReferenceCode',
          'id': referenceCode,
          'title': referenceName,
          isDefault: false,
          'isUserAction': true
        };
        this.platformSidebarStore.dispatch(new SetActivityFeedAction(activityInfo));
        this.sendActivityForViewActivityInQuestionnaire();
        break;
      case 'Edit':
        this.openEditor($event, 'Questionnaire');
        break;
      default:
        if (this.magicLinkModel.additionalCommands[$event.action.id]) {
          const showResponseCommand = this.magicLinkModel.additionalCommands[$event.action.id];
          showResponseCommand.fieldValues['DataItemId'] = $event.item.id;
          if ($event.fieldDefinition) {
            showResponseCommand.fieldValues['FieldKey'] = $event.fieldDefinition.key;
            showResponseCommand.fieldValues['FieldHeader'] = $event.fieldDefinition.header;
          }
          this.executeCommandWithHandler(showResponseCommand);
        }
    }
  }

  private sendActivityForViewActivityInQuestionnaire() {
    const activityCommand = this.getActivityForViewActivityInQuestionnaire();
    this.commandService.executePlatformCommand(activityCommand).pipe(take(1)).subscribe(response => {
      console.log('activity Sent');
    });
  }

  private openFile($event) {

    const executed = this.itpDesktopUtilityService.openForOpenFileListView($event.item);
    if (!executed) {
      this.magicLinkModel.additionalCommands['OpenFile'].fieldValues['DriveId'] = $event.item.cells['DriveId'].value;
      this.magicLinkModel.additionalCommands['OpenFile'].fieldValues['ItemId'] = $event.item.id;
      this.executeCommandWithHandler(this.magicLinkModel.additionalCommands['OpenFile']);
    }

  }

  private handleDriveActions($event: GridValueChangeEvent): boolean {
    if ($event.action) {
      switch ($event.action.id) {
        case 'Open':
          if ($event.item.cells['IsDrive'] && $event.item.cells['IsDrive'].value) {
            this.OpenDrive($event);
            return true;
          } else if ($event.item.cells['IsFolder'] && $event.item.cells['IsFolder'].value) {
            this.OpenFolder($event);
            return true;
          } else {
            this.openFile($event);
            return true;
          }
        case 'MarkStar':
          this.markStar($event);
          return true;
        case 'Share':
          this.openShareDialog($event);
          return true;
        case 'Restore':
          this.fileStoreCommonService.executeRestoreCommand($event.item.id);
          return true;
        case 'DeleteMultiple':
          this.deleteItems($event);
          return true;
        case 'DeleteForever':
          this.fileStoreCommonService.openDeleteFileOrFolderConfirmationDialog([{
            itemId: $event.item.id,
            type: $event.item.cells && $event.item.cells['IsFolder'] ? 'Folder' : ''
          }], true);
          break;
        case 'Edit':
          return this.editGridCellValue($event);
        case 'Move':
          this.moveItem($event);
          return true;
        case 'Navigate to Field':
          this.navigateToField($event);
          return true;
        default:
          const action: ContextMenuAction = {type: $event.action.id, title: $event.action.text};
          const o = $event.item;
          if (this.magicLinkModel.additionalCommands[$event.action.id]) {
            const command = this.magicLinkModel.additionalCommands[$event.action.id];
            command.fieldValues['ItemId'] = o.id;
            this.executeCommand(command);
          } else if (o.cells['Type'] && o.cells['RelativePath']) {
            const item: IconViewModel = this.fileStoreCommonService.getIconViewModel(o);
            this.fileStoreCommonService.handleActions(action, item, this.invalidateSubject, this.magicLinkModel);
          }
          return true;
      }
    }
    return false;
  }

  private magicLinkModelValueChangedHandler(command: any) {
    this.magicLinkModelValueChanged.emit(command);
  }

  private executeCommandToApi(command: PlatformCommand, callBack?: any) {
    this.fuseSplashScreenService.show();
    const dataSubject = new Subject<void|PlatformCommandResponse>();
    const observer = this.commandService.executePlatformCommand(command);
    if (observer) {
      observer.pipe(take(1)).subscribe(commandResponse => {
          console.log('[PlatformFilterHandler] Command Response', commandResponse);
          this.fuseSplashScreenService.hide();
          this.sendNecessaryActivityCommand(command);
          const downloadUrl = commandResponse.fieldValues['DownloadUrl'];
          if (downloadUrl) {
            this.fileManagementService.downloadOneTimeSignedUrl(downloadUrl, commandResponse.fieldValues['FileName']);
          } else {
            if (commandResponse.fieldValues['DownloadFileResponseModel']) {
              const downloadResponseModel = commandResponse.fieldValues['DownloadFileResponseModel'];
              const fileId = downloadResponseModel?.fileId;
              this.fileManagementService.downloadClientFileWithId(fileId).subscribe(payload => {
                this.fuseSplashScreenService.hide();
                this.fileManagementService.openSaveFileWindow(payload, downloadResponseModel.fileName);
              });
            }
            if (commandResponse.fieldValues['ReportResponse']) {
              this.magicLinkModel.tabBar.tabs[0].tabData['ReportResponse'] = commandResponse.fieldValues['ReportResponse'];
              this.invalidateSubject.invalidate('LoadReport');
            }
            if (commandResponse.fieldValues['RedirectCommand']) {
              this.executeCommandWithHandler(commandResponse.fieldValues['RedirectCommand'], callBack);
              return;
            }
            if (commandResponse.fieldValues['RedirectUrl']) {
              const redirectUrl = commandResponse.fieldValues['RedirectUrl'];
              if (redirectUrl !== this.router.url) {
                this.router.navigateByUrl(redirectUrl);
                return;
              }
              if (commandResponse.fieldValues['PlatformLinkModel']) {
                if((commandResponse.fieldValues['PlatformLinkModel'].fieldValues['ExtractFiles'])) {
                  this.subscribeForToastNotification();
                }
                else {
                  this.magicLinkModelValueChangedHandler({
                    id: 'PlatformToolContainerComponent',
                    value: commandResponse.fieldValues['PlatformLinkModel']
                  });
                }
              }
              if (commandResponse.fieldValues['Reload'] && commandResponse.fieldValues['Reload'] === true) {
                this.invalidateSubject.invalidate();
              }
              return;
            }
            else if (commandResponse.fieldValues['RedirectToExternalUrl']) {
              //console.log(`RedirectToExternalUrl : ${commandResponse.fieldValues['RedirectToExternalUrl']}`);
              window.open(commandResponse.fieldValues['RedirectToExternalUrl']);
              return;
            }
            if (commandResponse.fieldValues['PlatformLinkModel']) {
              this.magicLinkModelValueChangedHandler({
                id: 'PlatformToolContainerComponent',
                value: commandResponse.fieldValues['PlatformLinkModel']
              });
              return;
            }
            if (command.name === 'AddEventSourceModelCommand') {
              this.manageEventSourceCommandResponse(command, callBack);
              return;
            }
            if (commandResponse.fieldValues['ShowErrorMessage']) {
              this.snackBarService.showError(commandResponse.fieldValues['ShowErrorMessage']);
              return;
            }
            if (commandResponse.fieldValues['SnackBarMessage']) {
              const duration = commandResponse.fieldValues['SnackBarMessage'].length * 80;
              this.snackBarService.showInformation(commandResponse.fieldValues['SnackBarMessage'], duration);
              if (callBack) {
                callBack();
              } else {
                this.invalidateSubject.invalidate('OrbitaxDrive');
              }
              return;
            }
            if (commandResponse.fieldValues['FileId']) {
              this.fileManagementService.downloadClientFileWithId(commandResponse.fieldValues['FileId']).subscribe(payload => {
                this.fuseSplashScreenService.hide();
                let outputFileName = command.fieldValues['OutputFileName'];
                if(commandResponse.fieldValues['OutputFileName']){
                  outputFileName = commandResponse.fieldValues['OutputFileName'];
                }
                this.fileManagementService.openSaveFileWindow(payload, outputFileName);
              });
            }
            switch (command.name) {
              case 'DownloadAsZipCommand': {
                this.fileManagementService.downloadClientFileWithId(commandResponse.fieldValues.Payload.fileId).pipe().subscribe((payload: any) => {
                  this.fuseSplashScreenService.hide();
                  this.fileManagementService.openSaveFileWindow(payload, commandResponse.fieldValues.Payload.fileName);
                }, (error) => this.fuseSplashScreenService.hide());
                break;
              }
              case 'ImportAllQuestionnaireResponseCommand': {
                const sourceType = this.magicLinkModel.tabBar.tabs[this.magicLinkModel.tabBar.selectedIndex].tabData.SourceType;
                this.invalidateGridDataIfNeeded(sourceType);
              }
                break;
              case 'ImportCurrentQuestionnaireResponseCommand': {
                const sourceType = this.magicLinkModel.tabBar.tabs[this.magicLinkModel.tabBar.selectedIndex].tabData.SourceType;
                this.invalidateGridDataIfNeeded(sourceType);
                this.invalidateSubject.invalidate('Refresh');
              }
                break;
              case 'ToggleInformationFilterCommand':
                this.invalidateSubject.invalidate();
                break;
              case 'AddPlatformFieldsCommand':
                this.eliteFormFlowChartDataService.refreshPages();
            }

            if (commandResponse.fieldValues['Reload'] && commandResponse.fieldValues['Reload'] === true) {
              this.invalidateSubject.invalidate("Refresh");
            }

            dataSubject.next(commandResponse);
          }
          callBack(commandResponse);
        },
        err => {
          this.fuseSplashScreenService.hide();
        });
    }
    return dataSubject.asObservable();
  }


  private editGridCellValue(event: any) {
    if (event.item.cells['Type']?.value === 'File' || event.item.cells['Type']?.value === 'Folder') {
      this.openDirectoryEntryCellEditor(event);
      return false;
    }

    this.openEditor(event);
  }

  private updateQuestionnaireFieldDefinitions(state) {
    const queryObj: any = {};
    const flowChartSectionId = this.magicLinkModel.tabBar.tabs[this.magicLinkModel.tabBar.selectedIndex]
      .tabData['SurveyFlowchartSectionId'];
    const flowChartId = this.magicLinkModel.tabBar.tabs[this.magicLinkModel.tabBar.selectedIndex].tabData['FlowchartId'];
    const url = `${Configuration.getConfig(Api.FileStoreApi)}Query/Flowchart`;
    queryObj.excludeHiddenQuestion = true;
    queryObj.includeFirstFlowchart = false;
    queryObj.includeFlowChartsInfo = false;
    queryObj.includeSelectedFlowchart = [];
    queryObj.includeSelectedSections = [flowChartSectionId];
    queryObj.isManageFields = false;
    this.httpClient.post<any>(url, queryObj).subscribe(data => {
      this.saveQuestionnaireFieldDefinition(state.data.input.fieldDefinition, ((data['flowchartSections'])[flowChartId])[0]);
    });
  }

  private navigateToField($event: GridValueChangeEvent) {
    this.magicLinkModelValueChangedHandler({
      name: 'NavigateToField',
      value: $event
    });
  }

  private handleEventsByName($event: any) {
    switch ($event.name) {
      case 'CardViewCheckboxSelectionChanges':
        this.magicLinkModelValueChangedHandler({
          name: $event.name,
          value: $event
        });
        break;
    }
  }

  private hasUpdateFieldPermission(magicLinkModel: any) {
    const perissions = this.magicLinkModel.tabBar.tabs[0].tabData['FlowchartPermissions'];

    if(!perissions || perissions.length === 0 || perissions.includes(QnrPermissions.UpdateField)) {
      return true;
    }
    return false;
  }

  private openEditor(event: any, type: string = '') {
    let sourceType = this.magicLinkModel.tabBar.tabs[0].tabData['SourceType'];
    if (this.magicLinkModel.tabBar.tabs[0].tabData['ReplacementSourceKey']) {
      sourceType = this.magicLinkModel.tabBar.tabs[0].tabData['ReplacementSourceKey'];
    }
    const minWidth = '800px';
    const maxWidth = '1500px';
    const otherButtonCaption = 'Clear';
    this.magicLinkModel.tabBar.tabs[this.magicLinkModel.tabBar.selectedIndex].tabData['SurveyFlowchartSectionId'] = event.fieldSection.id;
    this.dialogService.showCellEditorDialog(event.item, event.fieldDefinition, minWidth, maxWidth,
      sourceType, null,
      {
        flowChartSectionId: this.magicLinkModel.tabBar.tabs[this.magicLinkModel.tabBar.selectedIndex].tabData['SurveyFlowchartSectionId'],
        flowChartId: this.magicLinkModel.tabBar.tabs[this.magicLinkModel.tabBar.selectedIndex].tabData['FlowchartId'],
        type: 'Questionnaire'
      }, otherButtonCaption).subscribe(state => {
      if (state) {
        if (state.action === 'OK' && !event.fieldDefinition.metaData['SkipUpdate']) {
          if (type === 'Questionnaire' && this.hasUpdateFieldPermission(this.magicLinkModel)) {
            this.updateQuestionnaireFieldDefinitions(state);
          }
          const command = this.getCommandWithFieldValues(event);
          delete command.fieldValues['IsCleared'];
          this.fileStoreCommonService.executeCommand(command).pipe().subscribe(() => {
            this.invalidateSubject.invalidate();
          });
        }
        if (state.action === 'OK' && event.fieldDefinition.metaData['SkipUpdate']) {
          this.invalidateSubject.invalidate();
        }
        if (state.action === otherButtonCaption) {
          const command = this.getCommandWithFieldValues(event);
          command.fieldValues['IsCleared'] = true;
          this.fileStoreCommonService.executeCommand(command).pipe().subscribe(() => {
            delete command.fieldValues['IsCleared'];
            this.invalidateSubject.invalidate();
          });
        }
      }
    });
  }

  private getCommandWithFieldValues(event: any) {
    const value = event.item.cells[event.fieldDefinition.key]?.value;
    const displayText = event.item.cells[event.fieldDefinition.key]?.displayText;
    const command = this.magicLinkModel?.additionalCommands['UpdateFlowchartItemCommand'];
    if (this.magicLinkModel.fieldValues['DirectoryId']) {
      command.fieldValues['DirectoryId'] = this.magicLinkModel.fieldValues['DirectoryId'];
    }
    command.fieldValues['ItemId'] = event.item?.id;
    command.fieldValues['FieldKey'] = event.fieldDefinition?.key;
    command.fieldValues['DirtyKeys'] = [event.fieldDefinition?.key];
    // we set section id. discussed with Shaon vai and further review
    command.fieldValues['FlowchartSectionId'] = this.magicLinkModel.tabBar.tabs[this.magicLinkModel.tabBar.selectedIndex].tabData['SurveyFlowchartSectionId'];
    PlatformToolEliteFormHandler.setRelatedFieldKeyPropertiesInCommand(event, command);
    if (displayText) {
      command.fieldValues[event.fieldDefinition.key + 'DisplayText'] = displayText;
    }
    command.fieldValues[event.fieldDefinition.key] = value;
    return command;
  }

  private executeOpenFlowExecutionCommand($event: any) {
    const command = new PlatformCommand('OpenFlowExecutionItemCommand', 'FileStoreApi');
    command.fieldValues['ItemId'] = this.magicLinkModel.fieldValues['ItemId'];
    command.fieldValues['FlowExecutionId'] = $event.item.id;
    this.executeCommandToApi(command);
  }

  private switchBasket() {
    const currentBasket = BasketProvider.getCurrentBasket();
    if (this.magicLinkModel.fieldValues['Tool-BasketId'] && currentBasket &&
      this.magicLinkModel.fieldValues['Tool-BasketId'] !== currentBasket.id) {
      const basket = BasketProvider.getBaskets().find(o => o.id === this.magicLinkModel.fieldValues['Tool-BasketId']);
      if (basket) {
        console.log('Switching basket from questionnaire using basketId');
        this.store.dispatch(new ChangeBasketAction(basket));
      }
    }
  }
}
